import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { useAuth0 } from "@auth0/auth0-react";
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";
import { LoginButton } from '../components/LoginButton';

export const LoginPage = () => {
	const { loginWithRedirect } = useAuth0();
	const location = useLocation();

	useEffect( () => {
		const handleLogin = async () => {
			await loginWithRedirect( {
				appState: {
					    returnTo: "/games",
				  },
			} );
		};
	
		const queryParams = new URLSearchParams( location.search );

		if ( queryParams.has( 'launch' ) ) {
			handleLogin();
		}
	},
	[
		loginWithRedirect,
		location.search
	] );
	

	return (
		<Box>
			<PrimarySearchAppBar />
			<LoginButton/>
		</Box>
	);
};
